import { LoadingOutlined, SearchOutlined } from '@ant-design/icons'

export interface SelectSuffixIconProps {
  loading: boolean
}

export const SelectSuffixIcon = ({ loading }: SelectSuffixIconProps) => {
  if (loading) {
    return <LoadingOutlined spin />
  }
  return <SearchOutlined />
}
